import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import baseUrl from "../../../baseUrl";
import {useForm} from "../../../hooks/useForm";
import {CompanySettlements} from "../CompanySettlements/CompanySettlements";
import {requester} from "../../../services/requester";
import {CompanyTotalData} from "../CompanyTotalData/CompanyTotalData";

export const EditCompanyForm = ({valueCompanyState}) => {
    const {year} = useParams();
    const request = requester();
    const [companyInfo, setCompanyInfo] = useState(
        {
            "create_on": "",
            "phone": "",
            "bullstat": "",
            "settlements": [],
            "id": "",
            "accountable_person": "",
            "address": "",
            "company_name": "",
            "company_note": "",
            "city": ""
        }
    );
    const [companySettlements, setCompanySettlements] = useState([]);

    const bullstat = Number(valueCompanyState.split(',')[2].trim());

    useEffect(() => {
        if (valueCompanyState.split(',').length === 3) {
            request.get(`${baseUrl()}/companies/${bullstat}`)
                .then((company) => {
                    setCompanyInfo(company);
                })
                .catch(err => alert(err.message || 'Грешка при зареждане.'))
        }

    }, [valueCompanyState])


    useEffect(() => {
        if (valueCompanyState.split(',').length === 3) {
            request.get(`${baseUrl()}/companies-initial-info/${year}/company/${bullstat}`)
                .then(company => {
                    setCompanySettlements(company);
                })
                .catch(err => alert(err.message || 'Грешка при зареждане.'))
        }

    }, [valueCompanyState])

    const {values: edit_values, changeHandler: changeEditData, onSubmitEditValues} = useForm({
        company_name: companyInfo.company_name,
        accountable_person: companyInfo.accountable_person,
        address: companyInfo.address,
        city: companyInfo.city,
        phone: companyInfo.phone,
        company_note: companyInfo.company_note,
    });

    useEffect(() => {
        onSubmitEditValues({
            company_name: companyInfo.company_name,
            accountable_person: companyInfo.accountable_person,
            address: companyInfo.address,
            city: companyInfo.city,
            phone: companyInfo.phone,
            company_note: companyInfo.company_note,
        })
    }, [companyInfo])

    const onSubmitEditData = (e) => {
        e.preventDefault();

        const body = {
            bullstat: Number(companyInfo.bullstat),
            company_name: edit_values.company_name,
            accountable_person: edit_values.accountable_person,
            address: edit_values.address,
            city: edit_values.city,
            phone: edit_values.phone,
            company_note: edit_values.company_note,
        };

        request.put(`${baseUrl()}/companies/${companyInfo.bullstat}`, body)
            .then(() => {
                alert("Ползвателя е успешно редактиран!");
            })
            .catch(err => alert(err.message || 'Възникна грешка при заявката.'));
    }

    return (<>
        <hr/>
        <form onSubmit={onSubmitEditData}>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="company_name" className="col-form-label">Фирма</label>
                </div>
                <div className="col-6" style={{marginLeft: "10px"}}>
                    <input className="col-11" id="company_name" type="text" name="company_name"
                           placeholder="Име на ползвателя"
                           value={edit_values.company_name}
                           onChange={changeEditData}
                    />
                </div>
            </div>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="accountable_person" className="col-form-label">Лице за контакт</label>
                </div>
                <div className="col-6" style={{marginLeft: "10px"}}>
                    <input className="col-11" id="accountable_person" type="text" name="accountable_person"
                           placeholder="Лице за контакт"
                           value={edit_values.accountable_person}
                           onChange={changeEditData}
                    />
                </div>
            </div>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="address" className="col-form-label">Адрес</label>
                </div>
                <div className="col-6" style={{marginLeft: "10px"}}>
                    <input className="col-11" id="address" type="text" name="address"
                           placeholder="Адрес"
                           value={edit_values.address}
                           onChange={changeEditData}
                    />
                </div>
            </div>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="city" className="col-form-label">Град</label>
                </div>
                <div className="col-6" style={{marginLeft: "10px"}}>
                    <input className="col-11" id="city" type="text" name="city"
                           placeholder="Град"
                           value={edit_values.city}
                           onChange={changeEditData}
                    />
                </div>
            </div>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="phone" className="col-form-label">Телефон</label>
                </div>
                <div className="col-6" style={{marginLeft: "10px"}}>
                    <input className="col-11" id="phone" type="text" name="phone"
                           placeholder="Телефон"
                           value={edit_values.phone}
                           onChange={changeEditData}
                    />
                </div>
            </div>
            <div className="row g-3 align-items-center">
                <div className="col-2">
                    <label htmlFor="company_note" className="col-form-label">Забележка</label>
                </div>
                <div className="col-6" style={{marginLeft: "10px"}}>
                    <input className="col-11" id="company_note" type="text" name="company_note"
                           placeholder="Забележка"
                           value={edit_values.company_note}
                           onChange={changeEditData}
                    />
                </div>
            </div>

            <button type="submit" className="btn btn-secondary mt-3">Редактирай</button>
        </form>
        <div style={{
            background: "var(--app-success-bg-soft)",
            borderTop: "2px solid var(--app-gold)",
            borderBottom: "2px solid var(--app-gold)",
            margin: "20px 0"
        }}>
            <h4 style={{color: "var(--app-gold)"}}>Общо за всички села:</h4>
            <CompanyTotalData bullstat={bullstat}/>
        </div>
        <h4 style={{color: "var(--app-gold)"}}>Села с декларирана земя:</h4>
        {companySettlements.length > 0 ?
            <CompanySettlements settlements={companySettlements} bullstat={bullstat}/> : (
                <h5 style={{color: "var(--app-danger-fg)"}}>Няма декларирани села</h5>)}
    </>);


};